// extracted by mini-css-extract-plugin
export var acceptButton = "_2d-5";
export var fullContent = "_2d-4";
export var link = "_2d-6";
export var linkIcon = "_2d-7";
export var sideContent = "_2d-3";
export var sideImage = "_2d-2";
export var sideImageWrapper = "_2d-1";
export var splitLayout = "_2d-0";